module.exports = __webpack_public_path__ + "static/media/DAC.e9ab5b94.jpg";